import styled from "styled-components";
import Checkbox from "@mui/material/Checkbox";
import { DatePicker } from "antd";
import ChevronDownIcon from "@assets/svg/Chevron_down.svg?react";

interface CommonFilterProps {
  isRtl?: boolean;
}

// Common styles shared across all filters
export const FilterContainer = styled.div`
  position: relative;
  min-width: 119px;
  width: fit-content;
`;

export const FilterButton = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  min-width: 119px;
  width: fit-content;
  height: 32px;
  background: #fff;
  border: 1px solid #e5e3f8;
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  color: #42536a;
  outline: none;
  transition: border 0.2s;
`;

export const ChevronContainer = styled.span`
  display: flex;
  align-items: center;
`;

export const LabelText = styled.span`
  flex: 1;
  text-align: start;
  font-size: 14px;
  font-weight: 500;
  color: #42536a;
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: 37px;
  left: 0;
  width: 268.5px;
  z-index: 9999;
  transform: translateY(10%) translateX(-50%);
`;

export const DropdownContent = styled.div`
  width: 268.5px;
  border-radius: 8px;
  padding: 12px;
  background: #fff;
  box-shadow: 0px 4.43px 23.26px 0px #0000000f;
  opacity: 1;
  display: flex;
  flex-direction: column;
`;

export const OptionsContainer = styled.div`
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 8px;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

// NameFilter specific styles
export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 8px;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  border-radius: 68px;
  border: 1px solid #e5e3f8;
  padding: 0 40px 0 16px;
  font-size: 14px;
  outline: none;
  font-weight: 600;
`;

export const SearchIcon = styled.span`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
  svg {
    fill: #75849f;
  }
`;

export const OptionContainer = styled.div<{ checked: boolean }>`
  width: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(props) => (props.checked ? "#F8FAFC" : "#fff")};
  cursor: pointer;
  border-radius: 4px;
  margin-bottom: 2px;
`;

export const OptionContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const OptionText = styled.span<{ checked: boolean }>`
  color: ${(props) => (props.checked ? "#5A3FFE" : "#3A3A3A")};
  font-weight: 500;
  font-size: 12px;
  user-select: none;
  margin-left: 6px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: 12px;
`;

export const StyledCheckbox = styled(Checkbox)`
  padding: 0;
  margin-left: 4px;
  margin-right: 4px;
`;

// ChannelFilter specific styles
export const ChannelOptionContainer = styled.div<{ checked: boolean }>`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(props) => (props.checked ? "#F8FAFC" : "#fff")};
  cursor: pointer;
  transition: background 0.2s;
  padding-inline: 12px;
  border-radius: 4px;
`;

export const ChannelIconContainer = styled.span`
  display: flex;
  align-items: center;
`;

export const ChannelText = styled.span<{ checked: boolean }>`
  color: ${(props) => (props.checked ? "#5A3FFE" : "#3a3a3a")};
  font-weight: 500;
  font-size: 12px;
  user-select: none;
  margin-left: 6px;
`;

export const ChannelContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledChannelIcon = styled.div`
  width: 24px;
  height: 24px;
  transform: translateY(3px);
`;

// PriceRangeFilter specific styles
export const PriceRangeContainer = styled.div`
  position: relative;
  min-width: 125px;
`;

export const PriceRangeButton = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 32px;
  background: #fff;
  border: 1px solid #e3e6f0;
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
  box-sizing: border-box;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  color: #42536a;
  outline: none;
  transition: border 0.2s;
`;

export const PriceRangeLabel = styled.span`
  flex: 1;
  text-align: start;
  font-size: 15px;
  font-weight: 500;
  color: #42536a;
`;

export const SliderContainer = styled.div`
  width: 100%;
  padding: 0 8px;
`;

export const RangeLabelsContainer = styled.div<CommonFilterProps>`
  flex-direction: ${(props) => (props.isRtl ? "row-reverse" : "row")};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RangeLabel = styled.span`
  color: #75849f;
  font-weight: 400;
  font-size: 11px;
  border: 1px solid #e3e6f0;
  border-radius: 8px;
  padding: 4px 8px;
  width: 113px;
  height: 36px;
  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: column;
`;

export const RangeLabelText = styled.span`
  font-size: 8px;
  font-weight: 400;
`;

export const RangeValueText = styled.span`
  color: black;
`;

// DateFilter specific styles
export const DateFilterContainer = styled.div`
  .custom-date-filter .ant-picker-input > input::placeholder {
    color: black !important;
    cursor: pointer;
  }
  .custom-date-filter {
    border-radius: 4px !important;
    font-size: 14px !important;
    border: 1px solid #e5e3f8 !important;
    cursor: pointer;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  color: #1a1a1a;
` as typeof DatePicker;

export const StyledRangePicker = styled(DatePicker.RangePicker)`
  cursor: pointer;
  color: #1a1a1a;
` as typeof DatePicker.RangePicker;

export const StyledChevronIcon = styled(ChevronDownIcon)`
  width: 12px;
  height: 12px;
  fill: #75849f;
`;
